var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetmlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_4226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8124 30.82C20.2633 30.82 19.7065 30.6376 19.2457 30.2652L0.898151 15.3387C-0.154009 14.4837 -0.303769 12.9446 0.560231 11.9034C1.42423 10.8622 2.97943 10.714 4.03159 11.569L22.3791 26.4955C23.4313 27.3543 23.5849 28.8896 22.717 29.9308C22.2294 30.5198 21.5228 30.8238 20.8086 30.8238",
    fill: "#36B77A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8796 13.8567C12.3267 13.8567 11.7737 13.6743 11.3129 13.3019L0.902678 4.82781C-0.149482 3.96901 -0.303082 2.4338 0.564758 1.38879C1.42876 0.347584 2.98396 0.199383 4.03612 1.05439L14.4464 9.52845C15.4985 10.3835 15.6483 11.9225 14.7843 12.9637C14.2966 13.5489 13.59 13.8529 12.8758 13.8529",
    fill: "#FCD639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96892 32.4999C9.4198 32.4999 8.863 32.3175 8.4022 31.9451L0.902678 25.8461C-0.149482 24.9911 -0.303082 23.4521 0.564758 22.4109C1.42876 21.3697 2.98396 21.2177 4.03612 22.0765L11.5395 28.1755C12.5916 29.0305 12.7452 30.5695 11.8774 31.6107C11.3897 32.1997 10.6832 32.5037 9.96892 32.5037",
    fill: "#29B5E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetmlogo);
export default __webpack_public_path__ + "static/media/retmlogo.0ce9209053fcdafa08e957b5c27581ef.svg";
export { ForwardRef as ReactComponent };